import dayjs from "dayjs"

export const dateDisabled = (date) => {
    // ensure the birthday is at least 18 years old
    let d = dayjs().subtract(18, 'year')
    if (date > d) {

        return true
    }
    return false
}
